<template>
  <div class="indentity_index" v-wechat-title="'身份认证'">
    <div class="content">
      <div class="svg-bg">
        <svg-icon :icon-class="sambleSvgPath" class-name="cur-icon"></svg-icon>
        <div>请准备好身份证、储蓄卡、信用卡进行拍照，</div>
        <div>核实真实身份保障合法权益</div>
      </div>

      <div class="button-list">
        <mt-button type="primary" size="large" @click="handleBtnClick">身份认证</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'IdentityIndex',
  comments: { SvgIcon },
  data() {
    return {
      sambleSvgPath: 'samble',
      token: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.token = this.$route.query.token;
    });
  },
  methods: {
    handleBtnClick() {
      this.replacePage('manualBankInfor', {
        token: this.token,
      });
    },
  },
};
</script>
